import "./ChristmasBall.css";

function ChristmasBall() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.4 17.9"
      xmlSpace="preserve"
      className="ChristmasBall"
    >
      <path
        className="BallPath"
        d="M11.4,6.5c-1.2-1.2-2.2-1.4-2.5-2.8H4.5C4.1,5.1,3.2,5.3,2,6.5s-2,2.9-2,4.7c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7
	C13.4,9.4,12.7,7.8,11.4,6.5z M3.2,11.9l0.3-1.5L2.4,9.3l1.5-0.2l0.7-1.4l0.7,1.4l1.5,0.2l-1.1,1.1L6,11.9l-1.3-0.7
	C4.5,11.1,3.2,11.9,3.2,11.9z M7.6,15.4l-1-0.5l-1,0.5l0.2-1.1L5,13.5l1.1-0.2l0.5-1l0.5,1l1.1,0.2l-0.8,0.8L7.6,15.4z M7.8,9
	l0.1-0.7L7.4,7.8l0.7-0.1l0.3-0.6l0.3,0.6l0.7,0.1L8.9,8.3L9,9L8.4,8.7C8.4,8.6,7.8,9,7.8,9z M10.5,12.4l-0.8-0.5l-0.8,0.4l0.2-0.9
	l-0.7-0.6l0.9-0.1l0.4-0.8l0.4,0.8l0.9,0.1l-0.7,0.6L10.5,12.4z M8.9,1.9C7.9,1.9,8.1,0,6.7,0S5.5,1.9,4.5,1.9V3H9V1.9H8.9z
	 M6.7,2.3C6.3,2.3,6,2,6,1.6c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7C7.4,1.9,7.1,2.3,6.7,2.3z"
      />
    </svg>
  );
}

export default ChristmasBall;
